let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c4a0F")).then(() => parcelRequire('7WlOv'));